var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSuffix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 55,
    cy: 115,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 85,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 55,
    cy: 145,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 55,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 85,
    cy: 115,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 85,
    cy: 85,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 85,
    cy: 145,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 115,
    cy: 55,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 115,
    cy: 115,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 115,
    cy: 85,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 115,
    cy: 145,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 145,
    cy: 55,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 145,
    cy: 115,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 145,
    cy: 85,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 145,
    cy: 145,
    r: 8,
    stroke: "#02276B",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSuffix);
export default __webpack_public_path__ + "static/media/CardSuffix.7461b84bea26eea728cde53dd474ac88.svg";
export { ForwardRef as ReactComponent };